import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Page from './views/Page.vue'
import Topic from './views/Topic.vue'
import Preview from './views/Preview.vue'
import SearchResult from './views/SearchResult.vue'



Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    { // recherche vide renvoie sur la home ? a voir ... ( evite de traiter les resultats null sur page searchResults )
      path: '/recherche/',
      /*
      name: 'SearchResult',
      component: SearchResult
      */
      name: 'home',
      component: Home
    },
    {
      path: '/recherche/:searchQuerry',
      name: 'SearchResult',
      component: SearchResult
    },
    {
      path: '/:topicId',
      name: 'Topic',
      component: Topic
    },
    {
      path: '/:topicId/:pageId', // todo - voir comment rendre la profondeur dynamique - pas jsute id propores a chaque niveaux ? // Vs navVue
      name: 'Page',
      component: Page
    },
    { // TODO !?
      path: '/preview',
      name: 'Preview',
      component: Preview
    },
  ]
})
